import React, { Component } from "react";
import { Button } from "react-bootstrap";
import toastr from "toastr";
import { getUserID } from "../../../../services/common/util";
import { submitCommunication } from "../../../../services/clinicPortalServices/communicationService";
import { fetchConversationUsers } from "../../../../services/clinicPortalServices/userService";

export default class ConversationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            users: [],
            toUser: "",
            subject: "",
            message: "",
            errors: []
        };
    }

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    componentDidMount() {
        fetchConversationUsers()
            .then((response) => {
                if (response.data && response.data.length) {
                    this.setState({ users: response.data.filter((user) => user._id !== getUserID()) });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    handleChange = (e) => {
        let stateVal = e.target.value;
        this.setState({ [e.target.name]: stateVal });
        if (e.target.value) {
            this.setState({ errors: this.state.errors.filter((item) => item !== e.target.name) });
        }
    };

    handleSubmit = () => {
        let errors = [];
        if (!this.state.subject) {
            errors.push("subject");
        }
        if (!this.state.message) {
            errors.push("message");
        }
        if (errors.length) {
            this.setState({ errors: errors });
        } else {
            const comment = {
                subject: this.state.subject,
                message: this.state.message,
                toUserId: this.state.toUser
            };
            submitCommunication(comment)
                .then((response) => {
                    this.props.handleClose();
                    this.props.context.componentParent.loadGridData();
                    toastr.success("Message sent successfully!");
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    render() {
        return (
            <div>
                <form>
                    <div className="row form-row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>
                                    To <abbr className="text-danger">*</abbr>
                                </label>
                                <select
                                    type="text"
                                    name="toUser"
                                    value={this.state.toUser}
                                    onChange={this.handleChange}
                                    className="form-control"
                                >
                                    <option value="">Select User</option>
                                    {this.state.users.map((user, index) => {
                                        return (
                                            <option value={user._id} key={index}>
                                                {`${user.first_name} ${user.last_name}`}
                                            </option>
                                        );
                                    })}
                                </select>
                                <div className={this.hasError("supportFacilityName") ? "inline-errormsg" : "hidden"}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                                        {" "}
                                        &nbsp;This field is required
                                    </i>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label>
                                    Subject <abbr className="text-danger">*</abbr>
                                </label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={this.state.subject}
                                    onChange={this.handleChange}
                                    className="form-control"
                                />
                                <div className={this.hasError("subject") ? "inline-errormsg" : "hidden"}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                                        {" "}
                                        &nbsp;This field is required
                                    </i>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label>
                                    Message <abbr className="text-danger">*</abbr>
                                </label>
                                <textarea
                                    rows={5}
                                    name="message"
                                    value={this.state.message}
                                    onChange={this.handleChange}
                                    className="form-control"
                                />
                                <div className={this.hasError("message") ? "inline-errormsg" : "hidden"}>
                                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                                        {" "}
                                        &nbsp;This field is required
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div
                        className="col-12"
                        style={{
                            paddingTop: "10px",
                            borderTop: "1px solid rgba(0,0,0,.2"
                        }}
                    >
                        <Button
                            variant="primary"
                            style={{ float: "right", marginLeft: "10px" }}
                            onClick={() => this.handleSubmit()}
                        >
                            Send Message
                        </Button>
                        <Button variant="secondary" style={{ float: "right" }} onClick={this.props.handleClose}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
